/** GAP: the error pill's light red fill has no rawColors token (only homePageTokens.background.negativeTrend, which is page-scoped). */
export const STATUS_PILL_ERROR_BG = "#FEE2E2";
